// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file pcf_mapping_service.proto (package pipeex.pcfmapping.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { StartOperationResponseSchema } from "./revit_service_pb";
import { file_revit_service } from "./revit_service_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pcf_mapping_service.proto.
 */
export const file_pcf_mapping_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_revit_service]);

/**
 * @generated from message pipeex.pcfmapping.v1.GetMappingsRequest
 */
export type GetMappingsRequest = Message<"pipeex.pcfmapping.v1.GetMappingsRequest"> & {
};

/**
 * Describes the message pipeex.pcfmapping.v1.GetMappingsRequest.
 * Use `create(GetMappingsRequestSchema)` to create a new message.
 */
export const GetMappingsRequestSchema: GenMessage<GetMappingsRequest> = /*@__PURE__*/
  messageDesc(file_pcf_mapping_service, 0);

/**
 * @generated from message pipeex.pcfmapping.v1.GetMappingsResponse
 */
export type GetMappingsResponse = Message<"pipeex.pcfmapping.v1.GetMappingsResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * PcfMappingConfig serialised as JSON.
   * Shape: { Mappings: [{Key, RevitParameterName, ParameterReference, IsEnabled, Notes, LastModified}],
   *          ConfigName, LastModified, Version }
   *
   * @generated from field: string config_json = 3;
   */
  configJson: string;
};

/**
 * Describes the message pipeex.pcfmapping.v1.GetMappingsResponse.
 * Use `create(GetMappingsResponseSchema)` to create a new message.
 */
export const GetMappingsResponseSchema: GenMessage<GetMappingsResponse> = /*@__PURE__*/
  messageDesc(file_pcf_mapping_service, 1);

/**
 * @generated from message pipeex.pcfmapping.v1.GetAllParameterNamesRequest
 */
export type GetAllParameterNamesRequest = Message<"pipeex.pcfmapping.v1.GetAllParameterNamesRequest"> & {
};

/**
 * Describes the message pipeex.pcfmapping.v1.GetAllParameterNamesRequest.
 * Use `create(GetAllParameterNamesRequestSchema)` to create a new message.
 */
export const GetAllParameterNamesRequestSchema: GenMessage<GetAllParameterNamesRequest> = /*@__PURE__*/
  messageDesc(file_pcf_mapping_service, 2);

/**
 * @generated from message pipeex.pcfmapping.v1.GetAllParameterNamesResponse
 */
export type GetAllParameterNamesResponse = Message<"pipeex.pcfmapping.v1.GetAllParameterNamesResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: repeated string parameter_names = 3;
   */
  parameterNames: string[];

  /**
   * @generated from field: repeated pipeex.pcfmapping.v1.PcfParameterCandidate parameter_candidates = 4;
   */
  parameterCandidates: PcfParameterCandidate[];
};

/**
 * Describes the message pipeex.pcfmapping.v1.GetAllParameterNamesResponse.
 * Use `create(GetAllParameterNamesResponseSchema)` to create a new message.
 */
export const GetAllParameterNamesResponseSchema: GenMessage<GetAllParameterNamesResponse> = /*@__PURE__*/
  messageDesc(file_pcf_mapping_service, 3);

/**
 * @generated from message pipeex.pcfmapping.v1.PcfParameterCandidate
 */
export type PcfParameterCandidate = Message<"pipeex.pcfmapping.v1.PcfParameterCandidate"> & {
  /**
   * @generated from field: pipeex.pcfmapping.v1.PcfParameterReferenceDto reference = 1;
   */
  reference?: PcfParameterReferenceDto | undefined;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: string group = 3;
   */
  group: string;

  /**
   * @generated from field: string data_type = 4;
   */
  dataType: string;

  /**
   * @generated from field: bool is_project_binding = 5;
   */
  isProjectBinding: boolean;

  /**
   * @generated from field: repeated string categories = 6;
   */
  categories: string[];
};

/**
 * Describes the message pipeex.pcfmapping.v1.PcfParameterCandidate.
 * Use `create(PcfParameterCandidateSchema)` to create a new message.
 */
export const PcfParameterCandidateSchema: GenMessage<PcfParameterCandidate> = /*@__PURE__*/
  messageDesc(file_pcf_mapping_service, 4);

/**
 * @generated from message pipeex.pcfmapping.v1.PcfParameterReferenceDto
 */
export type PcfParameterReferenceDto = Message<"pipeex.pcfmapping.v1.PcfParameterReferenceDto"> & {
  /**
   * @generated from field: int32 schema_version = 1;
   */
  schemaVersion: number;

  /**
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string scope = 4;
   */
  scope: string;

  /**
   * @generated from field: string shared_guid = 5;
   */
  sharedGuid: string;

  /**
   * @generated from field: string built_in_forge_type_id = 6;
   */
  builtInForgeTypeId: string;

  /**
   * @generated from field: optional int64 built_in_parameter = 7;
   */
  builtInParameter?: bigint | undefined;

  /**
   * @generated from field: string document_key = 8;
   */
  documentKey: string;

  /**
   * @generated from field: string owner_family_key = 9;
   */
  ownerFamilyKey: string;

  /**
   * @generated from field: optional int64 local_parameter_id = 10;
   */
  localParameterId?: bigint | undefined;
};

/**
 * Describes the message pipeex.pcfmapping.v1.PcfParameterReferenceDto.
 * Use `create(PcfParameterReferenceDtoSchema)` to create a new message.
 */
export const PcfParameterReferenceDtoSchema: GenMessage<PcfParameterReferenceDto> = /*@__PURE__*/
  messageDesc(file_pcf_mapping_service, 5);

/**
 * @generated from message pipeex.pcfmapping.v1.ValidateMappingsRequest
 */
export type ValidateMappingsRequest = Message<"pipeex.pcfmapping.v1.ValidateMappingsRequest"> & {
};

/**
 * Describes the message pipeex.pcfmapping.v1.ValidateMappingsRequest.
 * Use `create(ValidateMappingsRequestSchema)` to create a new message.
 */
export const ValidateMappingsRequestSchema: GenMessage<ValidateMappingsRequest> = /*@__PURE__*/
  messageDesc(file_pcf_mapping_service, 6);

/**
 * @generated from message pipeex.pcfmapping.v1.ValidateMappingsResponse
 */
export type ValidateMappingsResponse = Message<"pipeex.pcfmapping.v1.ValidateMappingsResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: repeated string validation_errors = 3;
   */
  validationErrors: string[];
};

/**
 * Describes the message pipeex.pcfmapping.v1.ValidateMappingsResponse.
 * Use `create(ValidateMappingsResponseSchema)` to create a new message.
 */
export const ValidateMappingsResponseSchema: GenMessage<ValidateMappingsResponse> = /*@__PURE__*/
  messageDesc(file_pcf_mapping_service, 7);

/**
 * @generated from message pipeex.pcfmapping.v1.ValidateIronPythonScriptRequest
 */
export type ValidateIronPythonScriptRequest = Message<"pipeex.pcfmapping.v1.ValidateIronPythonScriptRequest"> & {
  /**
   * @generated from field: string source = 1;
   */
  source: string;
};

/**
 * Describes the message pipeex.pcfmapping.v1.ValidateIronPythonScriptRequest.
 * Use `create(ValidateIronPythonScriptRequestSchema)` to create a new message.
 */
export const ValidateIronPythonScriptRequestSchema: GenMessage<ValidateIronPythonScriptRequest> = /*@__PURE__*/
  messageDesc(file_pcf_mapping_service, 8);

/**
 * @generated from message pipeex.pcfmapping.v1.ValidateIronPythonScriptResponse
 */
export type ValidateIronPythonScriptResponse = Message<"pipeex.pcfmapping.v1.ValidateIronPythonScriptResponse"> & {
  /**
   * True when the compiler ran. Syntax errors are returned in diagnostics.
   *
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: repeated pipeex.pcfmapping.v1.IronPythonCompileDiagnostic diagnostics = 3;
   */
  diagnostics: IronPythonCompileDiagnostic[];
};

/**
 * Describes the message pipeex.pcfmapping.v1.ValidateIronPythonScriptResponse.
 * Use `create(ValidateIronPythonScriptResponseSchema)` to create a new message.
 */
export const ValidateIronPythonScriptResponseSchema: GenMessage<ValidateIronPythonScriptResponse> = /*@__PURE__*/
  messageDesc(file_pcf_mapping_service, 9);

/**
 * @generated from message pipeex.pcfmapping.v1.IronPythonCompileDiagnostic
 */
export type IronPythonCompileDiagnostic = Message<"pipeex.pcfmapping.v1.IronPythonCompileDiagnostic"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;

  /**
   * @generated from field: int32 line = 2;
   */
  line: number;

  /**
   * @generated from field: int32 column = 3;
   */
  column: number;

  /**
   * @generated from field: pipeex.pcfmapping.v1.IronPythonDiagnosticSeverity severity = 4;
   */
  severity: IronPythonDiagnosticSeverity;
};

/**
 * Describes the message pipeex.pcfmapping.v1.IronPythonCompileDiagnostic.
 * Use `create(IronPythonCompileDiagnosticSchema)` to create a new message.
 */
export const IronPythonCompileDiagnosticSchema: GenMessage<IronPythonCompileDiagnostic> = /*@__PURE__*/
  messageDesc(file_pcf_mapping_service, 10);

/**
 * @generated from message pipeex.pcfmapping.v1.SaveMappingsRequest
 */
export type SaveMappingsRequest = Message<"pipeex.pcfmapping.v1.SaveMappingsRequest"> & {
  /**
   * PcfMappingConfig serialised as JSON
   *
   * @generated from field: string config_json = 1;
   */
  configJson: string;
};

/**
 * Describes the message pipeex.pcfmapping.v1.SaveMappingsRequest.
 * Use `create(SaveMappingsRequestSchema)` to create a new message.
 */
export const SaveMappingsRequestSchema: GenMessage<SaveMappingsRequest> = /*@__PURE__*/
  messageDesc(file_pcf_mapping_service, 11);

/**
 * @generated from message pipeex.pcfmapping.v1.SaveMappingsResponse
 */
export type SaveMappingsResponse = Message<"pipeex.pcfmapping.v1.SaveMappingsResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;
};

/**
 * Describes the message pipeex.pcfmapping.v1.SaveMappingsResponse.
 * Use `create(SaveMappingsResponseSchema)` to create a new message.
 */
export const SaveMappingsResponseSchema: GenMessage<SaveMappingsResponse> = /*@__PURE__*/
  messageDesc(file_pcf_mapping_service, 12);

/**
 * @generated from message pipeex.pcfmapping.v1.ResetToDefaultsRequest
 */
export type ResetToDefaultsRequest = Message<"pipeex.pcfmapping.v1.ResetToDefaultsRequest"> & {
};

/**
 * Describes the message pipeex.pcfmapping.v1.ResetToDefaultsRequest.
 * Use `create(ResetToDefaultsRequestSchema)` to create a new message.
 */
export const ResetToDefaultsRequestSchema: GenMessage<ResetToDefaultsRequest> = /*@__PURE__*/
  messageDesc(file_pcf_mapping_service, 13);

/**
 * @generated from message pipeex.pcfmapping.v1.ResetToDefaultsResponse
 */
export type ResetToDefaultsResponse = Message<"pipeex.pcfmapping.v1.ResetToDefaultsResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;
};

/**
 * Describes the message pipeex.pcfmapping.v1.ResetToDefaultsResponse.
 * Use `create(ResetToDefaultsResponseSchema)` to create a new message.
 */
export const ResetToDefaultsResponseSchema: GenMessage<ResetToDefaultsResponse> = /*@__PURE__*/
  messageDesc(file_pcf_mapping_service, 14);

/**
 * @generated from message pipeex.pcfmapping.v1.ExportMappingsRequest
 */
export type ExportMappingsRequest = Message<"pipeex.pcfmapping.v1.ExportMappingsRequest"> & {
};

/**
 * Describes the message pipeex.pcfmapping.v1.ExportMappingsRequest.
 * Use `create(ExportMappingsRequestSchema)` to create a new message.
 */
export const ExportMappingsRequestSchema: GenMessage<ExportMappingsRequest> = /*@__PURE__*/
  messageDesc(file_pcf_mapping_service, 15);

/**
 * @generated from message pipeex.pcfmapping.v1.ExportMappingsResponse
 */
export type ExportMappingsResponse = Message<"pipeex.pcfmapping.v1.ExportMappingsResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: string json = 3;
   */
  json: string;
};

/**
 * Describes the message pipeex.pcfmapping.v1.ExportMappingsResponse.
 * Use `create(ExportMappingsResponseSchema)` to create a new message.
 */
export const ExportMappingsResponseSchema: GenMessage<ExportMappingsResponse> = /*@__PURE__*/
  messageDesc(file_pcf_mapping_service, 16);

/**
 * @generated from message pipeex.pcfmapping.v1.ImportMappingsRequest
 */
export type ImportMappingsRequest = Message<"pipeex.pcfmapping.v1.ImportMappingsRequest"> & {
  /**
   * @generated from field: string json = 1;
   */
  json: string;
};

/**
 * Describes the message pipeex.pcfmapping.v1.ImportMappingsRequest.
 * Use `create(ImportMappingsRequestSchema)` to create a new message.
 */
export const ImportMappingsRequestSchema: GenMessage<ImportMappingsRequest> = /*@__PURE__*/
  messageDesc(file_pcf_mapping_service, 17);

/**
 * @generated from message pipeex.pcfmapping.v1.ImportMappingsResponse
 */
export type ImportMappingsResponse = Message<"pipeex.pcfmapping.v1.ImportMappingsResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;
};

/**
 * Describes the message pipeex.pcfmapping.v1.ImportMappingsResponse.
 * Use `create(ImportMappingsResponseSchema)` to create a new message.
 */
export const ImportMappingsResponseSchema: GenMessage<ImportMappingsResponse> = /*@__PURE__*/
  messageDesc(file_pcf_mapping_service, 18);

/**
 * @generated from enum pipeex.pcfmapping.v1.IronPythonDiagnosticSeverity
 */
export enum IronPythonDiagnosticSeverity {
  /**
   * @generated from enum value: IRON_PYTHON_DIAGNOSTIC_SEVERITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: IRON_PYTHON_DIAGNOSTIC_SEVERITY_ERROR = 1;
   */
  ERROR = 1,

  /**
   * @generated from enum value: IRON_PYTHON_DIAGNOSTIC_SEVERITY_WARNING = 2;
   */
  WARNING = 2,
}

/**
 * Describes the enum pipeex.pcfmapping.v1.IronPythonDiagnosticSeverity.
 */
export const IronPythonDiagnosticSeveritySchema: GenEnum<IronPythonDiagnosticSeverity> = /*@__PURE__*/
  enumDesc(file_pcf_mapping_service, 0);

/**
 * PCF parameter mapping CRUD operations.
 * Replaces the WebView2 RevitBridge.PcfMappingBridgeApi surface.
 *
 * @generated from service pipeex.pcfmapping.v1.PcfMappingService
 */
export const PcfMappingService: GenService<{
  /**
   * Get current PCF parameter mapping configuration
   *
   * @generated from rpc pipeex.pcfmapping.v1.PcfMappingService.GetMappings
   */
  getMappings: {
    methodKind: "unary";
    input: typeof GetMappingsRequestSchema;
    output: typeof GetMappingsResponseSchema;
  },
  /**
   * Get all available Revit parameter names from the active document
   *
   * @generated from rpc pipeex.pcfmapping.v1.PcfMappingService.GetAllParameterNames
   */
  getAllParameterNames: {
    methodKind: "unary";
    input: typeof GetAllParameterNamesRequestSchema;
    output: typeof GetAllParameterNamesResponseSchema;
  },
  /**
   * Start parameter-name scan as a host operation with live progress.
   *
   * @generated from rpc pipeex.pcfmapping.v1.PcfMappingService.StartGetAllParameterNames
   */
  startGetAllParameterNames: {
    methodKind: "unary";
    input: typeof GetAllParameterNamesRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
  /**
   * Validate current mapping configuration for errors
   *
   * @generated from rpc pipeex.pcfmapping.v1.PcfMappingService.ValidateMappings
   */
  validateMappings: {
    methodKind: "unary";
    input: typeof ValidateMappingsRequestSchema;
    output: typeof ValidateMappingsResponseSchema;
  },
  /**
   * Start mapping validation as a host operation with live progress.
   *
   * @generated from rpc pipeex.pcfmapping.v1.PcfMappingService.StartValidateMappings
   */
  startValidateMappings: {
    methodKind: "unary";
    input: typeof ValidateMappingsRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
  /**
   * Compile a formula draft with the plugin's IronPython runtime without executing it.
   *
   * @generated from rpc pipeex.pcfmapping.v1.PcfMappingService.ValidateIronPythonScript
   */
  validateIronPythonScript: {
    methodKind: "unary";
    input: typeof ValidateIronPythonScriptRequestSchema;
    output: typeof ValidateIronPythonScriptResponseSchema;
  },
  /**
   * Save/update PCF mapping configuration
   *
   * @generated from rpc pipeex.pcfmapping.v1.PcfMappingService.SaveMappings
   */
  saveMappings: {
    methodKind: "unary";
    input: typeof SaveMappingsRequestSchema;
    output: typeof SaveMappingsResponseSchema;
  },
  /**
   * Start mapping save as a host operation with live progress.
   *
   * @generated from rpc pipeex.pcfmapping.v1.PcfMappingService.StartSaveMappings
   */
  startSaveMappings: {
    methodKind: "unary";
    input: typeof SaveMappingsRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
  /**
   * Reset mapping configuration to built-in defaults
   *
   * @generated from rpc pipeex.pcfmapping.v1.PcfMappingService.ResetToDefaults
   */
  resetToDefaults: {
    methodKind: "unary";
    input: typeof ResetToDefaultsRequestSchema;
    output: typeof ResetToDefaultsResponseSchema;
  },
  /**
   * Start mapping reset as a host operation with live progress.
   *
   * @generated from rpc pipeex.pcfmapping.v1.PcfMappingService.StartResetToDefaults
   */
  startResetToDefaults: {
    methodKind: "unary";
    input: typeof ResetToDefaultsRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
  /**
   * Export current mapping configuration as portable JSON
   *
   * @generated from rpc pipeex.pcfmapping.v1.PcfMappingService.ExportMappings
   */
  exportMappings: {
    methodKind: "unary";
    input: typeof ExportMappingsRequestSchema;
    output: typeof ExportMappingsResponseSchema;
  },
  /**
   * Import mapping configuration from previously exported JSON
   *
   * @generated from rpc pipeex.pcfmapping.v1.PcfMappingService.ImportMappings
   */
  importMappings: {
    methodKind: "unary";
    input: typeof ImportMappingsRequestSchema;
    output: typeof ImportMappingsResponseSchema;
  },
  /**
   * Start mapping import as a host operation with live progress.
   *
   * @generated from rpc pipeex.pcfmapping.v1.PcfMappingService.StartImportMappings
   */
  startImportMappings: {
    methodKind: "unary";
    input: typeof ImportMappingsRequestSchema;
    output: typeof StartOperationResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_pcf_mapping_service, 0);

